var exports = {
  "kL": "ChannelPinsPopout.module__container___dW9DVm",
  "wx": "ChannelPinsPopout.module__header___dW9DVm",
  "rf": "ChannelPinsPopout.module__body___dW9DVm",
  "DD": "ChannelPinsPopout.module__title___dW9DVm",
  "J3": "ChannelPinsPopout.module__iconLarge___dW9DVm",
};

module.exports = exports;
